// extracted by mini-css-extract-plugin
export default {"wrapper":"Yq-z","response":"Zq-z","error":"_q-z","disabled":"ar-z","buttons":"br-z","feedbackQuestionSection":"cr-z","yesNoWrapper":"dr-z"};